import { useState } from "react";
import { useParams } from "react-router";

import { useQuery } from "@tanstack/react-query";
import { Grid2, Tab, Tabs } from "@mui/material";

import PageHeader from "../components/PageHeader";
import ContainerLoading from "../components/ContainerLoading";
import ResponsibleDetailsList from "../components/ResponsibleDetailsList";
import ResponsableDepedentList from "../components/ResponsableDepedentList";
import BillingHistory from "../components/BillingHistory";

import { getParentById } from "../services/parents";

const ResponsibleDetails = () => {
  const { id } = useParams();
  const [value, setValue] = useState("1");

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["getParentById" + id],
    queryFn: async () => await getParentById(Number(id)),
    initialData: {},
  });

  const handleChangeValue = (
    _event: React.SyntheticEvent,
    newValue: string
  ) => {
    setValue(newValue);
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title={data?.fullName}
          subtitle="Informações do responsável"
          back
        />

        <Grid2 size={12}>
          <Tabs
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
            onChange={handleChangeValue}
            value={value}
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="DADOS" value="1" />
            <Tab label="DEPENDENTES" value="2" />

            <Tab label="FINANCEIRO" value="3" />
          </Tabs>
        </Grid2>
        {value === "1" && (
          <Grid2 size={12}>
            <ResponsibleDetailsList data={data} refetch={refetch} />
          </Grid2>
        )}
        {value === "2" && (
          <Grid2 size={12}>
            <ResponsableDepedentList
              depedents={data?.student || []}
              responsableId={data.id}
              refetch={refetch}
            />
          </Grid2>
        )}
        {value === "3" && (
          <Grid2 size={12}>
            <BillingHistory data={data.payments} refetch={refetch} />
          </Grid2>
        )}
      </Grid2>
    </ContainerLoading>
  );
};

export default ResponsibleDetails;
